/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RemoveHexFromCollection2MutationVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type RemoveHexFromCollection2Mutation = {
  readonly __typename: "Mutation";
  readonly removeProjectFromCollection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
  };
};

export type SetHexArchived2MutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  archived: Types.Scalars["Boolean"]["input"];
}>;

export type SetHexArchived2Mutation = {
  readonly __typename: "Mutation";
  readonly setHexArchived: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly archivedDate: c.DateTimeString | null;
  };
};

export type SetHexSharedWithSupportMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type SetHexSharedWithSupportMutation = {
  readonly __typename: "Mutation";
  readonly shareHexWithSupport: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly sharedWithSupport: boolean;
  };
};

export type OptionsMenuHexSharedWithSupportQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type OptionsMenuHexSharedWithSupportQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly sharedWithSupport: boolean;
  };
};

export const RemoveHexFromCollection2Document = /*#__PURE__*/ gql`
  mutation RemoveHexFromCollection2(
    $collectionId: CollectionId!
    $hexId: HexId!
  ) {
    removeProjectFromCollection(collectionId: $collectionId, hexId: $hexId) {
      id
    }
  }
`;
export type RemoveHexFromCollection2MutationFn = Apollo.MutationFunction<
  RemoveHexFromCollection2Mutation,
  RemoveHexFromCollection2MutationVariables
>;

/**
 * __useRemoveHexFromCollection2Mutation__
 *
 * To run a mutation, you first call `useRemoveHexFromCollection2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHexFromCollection2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHexFromCollection2Mutation, { data, loading, error }] = useRemoveHexFromCollection2Mutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useRemoveHexFromCollection2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveHexFromCollection2Mutation,
    RemoveHexFromCollection2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveHexFromCollection2Mutation,
    RemoveHexFromCollection2MutationVariables
  >(RemoveHexFromCollection2Document, options);
}
export type RemoveHexFromCollection2MutationHookResult = ReturnType<
  typeof useRemoveHexFromCollection2Mutation
>;
export type RemoveHexFromCollection2MutationResult =
  Apollo.MutationResult<RemoveHexFromCollection2Mutation>;
export type RemoveHexFromCollection2MutationOptions =
  Apollo.BaseMutationOptions<
    RemoveHexFromCollection2Mutation,
    RemoveHexFromCollection2MutationVariables
  >;
export const SetHexArchived2Document = /*#__PURE__*/ gql`
  mutation SetHexArchived2($hexId: HexId!, $archived: Boolean!) {
    setHexArchived(hexId: $hexId, archived: $archived) {
      id
      archivedDate
    }
  }
`;
export type SetHexArchived2MutationFn = Apollo.MutationFunction<
  SetHexArchived2Mutation,
  SetHexArchived2MutationVariables
>;

/**
 * __useSetHexArchived2Mutation__
 *
 * To run a mutation, you first call `useSetHexArchived2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHexArchived2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHexArchived2Mutation, { data, loading, error }] = useSetHexArchived2Mutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetHexArchived2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetHexArchived2Mutation,
    SetHexArchived2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetHexArchived2Mutation,
    SetHexArchived2MutationVariables
  >(SetHexArchived2Document, options);
}
export type SetHexArchived2MutationHookResult = ReturnType<
  typeof useSetHexArchived2Mutation
>;
export type SetHexArchived2MutationResult =
  Apollo.MutationResult<SetHexArchived2Mutation>;
export type SetHexArchived2MutationOptions = Apollo.BaseMutationOptions<
  SetHexArchived2Mutation,
  SetHexArchived2MutationVariables
>;
export const SetHexSharedWithSupportDocument = /*#__PURE__*/ gql`
  mutation SetHexSharedWithSupport($hexId: HexId!) {
    shareHexWithSupport(hexId: $hexId) {
      id
      sharedWithSupport
    }
  }
`;
export type SetHexSharedWithSupportMutationFn = Apollo.MutationFunction<
  SetHexSharedWithSupportMutation,
  SetHexSharedWithSupportMutationVariables
>;

/**
 * __useSetHexSharedWithSupportMutation__
 *
 * To run a mutation, you first call `useSetHexSharedWithSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHexSharedWithSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHexSharedWithSupportMutation, { data, loading, error }] = useSetHexSharedWithSupportMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useSetHexSharedWithSupportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetHexSharedWithSupportMutation,
    SetHexSharedWithSupportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetHexSharedWithSupportMutation,
    SetHexSharedWithSupportMutationVariables
  >(SetHexSharedWithSupportDocument, options);
}
export type SetHexSharedWithSupportMutationHookResult = ReturnType<
  typeof useSetHexSharedWithSupportMutation
>;
export type SetHexSharedWithSupportMutationResult =
  Apollo.MutationResult<SetHexSharedWithSupportMutation>;
export type SetHexSharedWithSupportMutationOptions = Apollo.BaseMutationOptions<
  SetHexSharedWithSupportMutation,
  SetHexSharedWithSupportMutationVariables
>;
export const OptionsMenuHexSharedWithSupportDocument = /*#__PURE__*/ gql`
  query OptionsMenuHexSharedWithSupport($hexId: HexId!) {
    hexById(hexId: $hexId) {
      id
      sharedWithSupport
    }
  }
`;

/**
 * __useOptionsMenuHexSharedWithSupportQuery__
 *
 * To run a query within a React component, call `useOptionsMenuHexSharedWithSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsMenuHexSharedWithSupportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsMenuHexSharedWithSupportQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useOptionsMenuHexSharedWithSupportQuery(
  baseOptions: Apollo.QueryHookOptions<
    OptionsMenuHexSharedWithSupportQuery,
    OptionsMenuHexSharedWithSupportQueryVariables
  > &
    (
      | {
          variables: OptionsMenuHexSharedWithSupportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OptionsMenuHexSharedWithSupportQuery,
    OptionsMenuHexSharedWithSupportQueryVariables
  >(OptionsMenuHexSharedWithSupportDocument, options);
}
export function useOptionsMenuHexSharedWithSupportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OptionsMenuHexSharedWithSupportQuery,
    OptionsMenuHexSharedWithSupportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OptionsMenuHexSharedWithSupportQuery,
    OptionsMenuHexSharedWithSupportQueryVariables
  >(OptionsMenuHexSharedWithSupportDocument, options);
}
export function useOptionsMenuHexSharedWithSupportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OptionsMenuHexSharedWithSupportQuery,
    OptionsMenuHexSharedWithSupportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OptionsMenuHexSharedWithSupportQuery,
    OptionsMenuHexSharedWithSupportQueryVariables
  >(OptionsMenuHexSharedWithSupportDocument, options);
}
export type OptionsMenuHexSharedWithSupportQueryHookResult = ReturnType<
  typeof useOptionsMenuHexSharedWithSupportQuery
>;
export type OptionsMenuHexSharedWithSupportLazyQueryHookResult = ReturnType<
  typeof useOptionsMenuHexSharedWithSupportLazyQuery
>;
export type OptionsMenuHexSharedWithSupportSuspenseQueryHookResult = ReturnType<
  typeof useOptionsMenuHexSharedWithSupportSuspenseQuery
>;
export type OptionsMenuHexSharedWithSupportQueryResult = Apollo.QueryResult<
  OptionsMenuHexSharedWithSupportQuery,
  OptionsMenuHexSharedWithSupportQueryVariables
>;
